import type { Persona } from './ai-policy';

/** 策略脚本版本号（任何行为调整都升版本，榜面显式展示）。 */
export const AI_VERSION = 'policy-1.0';

export interface AiRosterEntry {
  aiId: string;
  callsign: string;
  persona: Persona;
  /** AI 个人熵（固定值；与真人个人熵同构，仅用于 offers 流）。 */
  entropy: string;
}

/** 每日陪榜 3 只 AI：传统策略脚本，非生成式 AI（itch.io 口径无需披露）。 */
export const AI_ROSTER: readonly AiRosterEntry[] = [
  { aiId: 'ai-1', callsign: '稳剑', persona: 'conservative', entropy: 'a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1a1' },
  { aiId: 'ai-2', callsign: '贪星', persona: 'greedy', entropy: 'b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2b2' },
  { aiId: 'ai-3', callsign: '疯刃', persona: 'extreme', entropy: 'c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3c3' },
];
